import type { BreadcrumbLink } from '@noths/polaris-design-system-candidate-components';

import {
  INSPIRATION_HUB_INTRO,
  INSPIRATION_HUB_TITLE,
} from 'src/components/templates/InspirationLayout/copy';
import type { InspirationLayoutProps } from 'src/components/templates/InspirationLayout/InspirationLayout';
import { INSPIRATION_HUB_PATH } from 'src/utils/inspirationUrls';
import type { InspirationTab } from './buildInspirationTabs';

const SITE_ORIGIN = 'https://www.notonthehighstreet.com';
const SITE_NAME = 'notonthehighstreet.com';

/** Home, then the hub: where every Inspiration page's breadcrumbs start. */
export const INSPIRATION_BREADCRUMBS: BreadcrumbLink[] = [
  { rel: '/', text: 'Home' },
  { rel: INSPIRATION_HUB_PATH, text: 'Inspiration' },
];

interface InspirationLayoutOptions {
  activeTabId: string;
  /** Breadcrumbs after Home and Inspiration. */
  crumbs: BreadcrumbLink[];
  /** The page's own URL, for the canonical link. */
  href: string;
  tabs: InspirationTab[];
  /** Lead the page title, most specific first, ahead of the hub and site names. */
  titleParts: string[];
}

export const toInspirationLayoutProps = ({
  activeTabId,
  crumbs,
  href,
  tabs,
  titleParts,
}: InspirationLayoutOptions): Omit<InspirationLayoutProps, 'children'> => ({
  activeTabId,
  breadcrumbs: [...INSPIRATION_BREADCRUMBS, ...crumbs],
  seo: {
    canonical: `${SITE_ORIGIN}${href}`,
    description: INSPIRATION_HUB_INTRO,
    title: [...titleParts, INSPIRATION_HUB_TITLE, SITE_NAME].join(' | '),
  },
  tabs: tabs.map(({ href: tabHref, id, label }) => ({ href: tabHref, id, label })),
});
